module.exports = __webpack_public_path__ + "img/arches.ee5203e2.jpg";